import { parseScreenParam } from '../app/qsortV2/lib/utils'
import { ALL_LANGUAGES } from '../i18n/constants'
import { DEFAULT_PARAMS } from './parameters'
import { ConvertedBrandParams, FullParameters, QSortV2Params } from './types'

export const TEST_SLUG = 'recruitdemo2'
export const TEST_SOURCE = 'testsource'

export const defaultQSortV2Params: QSortV2Params = {
    isQSortV2: false,
    nBucket: 9,
    nSets: 3,
    hasPower: true,
    reflectionMode: 0,
    stmsPerScreen: 'M=5x1;D=5x1',
    promptRankMidBucket: false,
}

// TODO remove all tests
export const testPluxeeColors = {
    ultraGreen: '#00EB5E', // title, bg of buttons
    lightGreen: '#C7FCCA', // bloc, bg color, hover of buttons
    deepBlue: '#221C46', // bg, body copy font color, borders of buttons
    white: '#ffffff', // body copy (bg?)
}
const test3 = '#00EB5E'
const test = '#C7FCCA'
const test2 = '#221C46'
const updateWholeTheme = {
    mode: 'light',
    primary: {
        main: '#00EB5E',
        contrastText: 'rgba(0, 0, 0, 0.87)',
        light: 'rgb(51, 239, 126)',
        dark: 'rgb(0, 164, 65)',
    },
    text: {
        primary: '#221C46',
        secondary: 'rgba(34, 28, 70, 0.7)',
        disabled: 'rgba(34, 28, 70, 0.38)',
    },
    common: {
        black: '#221C46',
        white: '#ffd600',
    },
    secondary: {
        main: '#C7FCCA',
        light: 'rgb(210, 252, 212)',
        dark: 'rgb(139, 176, 141)',
        contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    error: {
        main: '#d32f2f',
        light: '#ef5350',
        dark: '#c62828',
        contrastText: '#fff',
    },
    warning: {
        main: '#ed6c02',
        light: '#ff9800',
        dark: '#e65100',
        contrastText: '#fff',
    },
    info: {
        main: '#0288d1',
        light: '#03a9f4',
        dark: '#01579b',
        contrastText: '#fff',
    },
    success: {
        main: '#2e7d32',
        light: '#4caf50',
        dark: '#1b5e20',
        contrastText: '#fff',
    },
    grey: {
        '50': 'rgba(243, 243, 245, 0.5)',
        '100': 'rgba(232, 232, 236, 0.5)',
        '200': 'rgba(210, 209, 218, 0.5)',
        '300': 'rgba(188, 186, 199, 0.5)',
        '400': 'rgba(144, 141, 162, 0.5)',
        '500': 'rgba(34, 28, 70, 0.5)',
        '600': 'rgba(30, 25, 63, 0.5)',
        '700': 'rgba(27, 22, 56, 0.5)',
        '800': 'rgba(23, 19, 49, 0.5)',
        '900': 'rgba(20, 16, 42, 0.5)',
        A100: 'rgba(210, 209, 218, 0.5)',
        A200: 'rgba(166, 164, 181, 0.5)',
        A400: 'rgba(122, 118, 144, 0.5)',
        A700: 'rgba(78, 73, 107, 0.5)',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    divider: 'rgba(0, 0, 0, 0.12)',
    background: {
        paper: 'rgb(242, 203, 0)',
        default: '#ffd600',
    },
    action: {
        active: 'rgba(0, 0, 0, 0.54)',
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        disabled: 'rgba(0, 0, 0, 0.26)',
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12,
    },
}

export const fitmeColors: ConvertedBrandParams = {
    primaryColor: '#55afbb', // primary color palette, defaut brand.bg param
    secondaryColor: '#5DC1B9', // next button
    textColor: '#5a5a5a', // text primary color palette
    backgroundColor: '#ffffff',
}

export const defaultParamsFitme: FullParameters = {
    brandParams: {
        companyName: 'Fitme',
        companyLogoUrl:
            'https://assessment.twegos.com/data/logos/f__fitme_logo_square02.png?v=20230608',
        brandImageUrl:
            'https://assessment.twegos.com/data/brandimage/f__valuefit.png',
        // brandImageUrlMobile:
        //     'https://assessment.twegos.com/data/brandimage/f__valuefit.png',
        brandText1: {
            'en-us': 'Tell us, what is your ideal work environment?',
            'en-be': 'Tell us, what is your ideal work environment?',
            'fr-fr':
                'Dites-nous quel est votre environnement de travail idéal ?',
            'fr-be':
                'Dites-nous quel est votre environnement de travail idéal ?',
            'nl-be': 'Vertel ons, wat is uw ideale werkomgeving?',
        },
        brandText2: {
            'en-us':
                'Try to imagine your ideal work environment and describe it by selecting the statement you prefer.',
            'en-be':
                'Try to imagine your ideal work environment and describe it by selecting the statement you prefer.',
            'fr-fr':
                "Essayez d'imaginer votre environnement de travail idéal en sélectionnant votre proposition préférée.",
            'fr-be':
                "Essayez d'imaginer votre environnement de travail idéal en sélectionnant votre proposition préférée.",
            'nl-be':
                'Probeer je ideale werkomgeving voor te stellen en beschrijf deze door de uitspraak te selecteren die je voorkeur heeft.',
        },
        ...fitmeColors,
        availableLanguages: [...ALL_LANGUAGES], //TODO less languages?
        returnUrl: 'https://fitme.jobs',
    },
    assessmentParams: {
        is360: false,
        is360WithLeadership: false,
        is360WithWorkenv: false,
        // (3bis?) Intro screen
        hasIntro: false,
        // (4) 2nd Brand screen #2
        has2ndBranding: false,
        // (5) Instruction screen
        hasHowTo: true,
        // (8|12) Intermezzo screen #1, #2, #3
        hasAwardRound: true,
        // (9|13) Ranking screen #1, #2
        hasConfirmRound: true,
        // (15) Intermezzo screen #4
        hasHowToBuckets: true,
        delayedChoiceDuration: 500, // [ms]
        ...DEFAULT_PARAMS,
        submit_confirmation: 0,
        simple_progress_bar: false,
        download_report: 1,
        values_with_icons: 1,
        ...defaultQSortV2Params,
    },
}

export const defaultScreenParams = parseScreenParam(
    defaultParamsFitme.assessmentParams['stmsPerScreen']
)